<template>
  <transition name="fade">
    <div v-if="showAnnouncement" class="announcement-bar">
      {{ t('announcement') }}
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  showAnnouncement: {
    type: Boolean,
    default: false
  }
});

const className = computed(() => {
  return {
    'is-hidden': !props.show
  };
});
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.announcement-bar {
  background-color: #ffcc00;
  color: #333;
  padding: 8px;
  text-align: center;
  font-weight: bold;
}
.is-hidden {
  display: none;
}
</style>
